/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchObserverLinkResponseItem } from './search-observer-link-response-item';


export interface SearchObserverLinkResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchObserverLinkResponseItem> | null;
}

